import { UserEntity, UserFilter, UserTypeEntity } from '../../models'

export const SET_USERS_LOADED = 'SET_USERS_LOADED'
export const SET_USERS = 'SET_USERS'
export const SET_USER_FILTER = 'SET_USER_FILTER'
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
export const SET_USER_TYPES_LOADED = 'SET_USER_TYPES_LOADED'
export const SET_USER_TYPES = 'SET_USER_TYPES'

export interface UserState {
  users: UserEntity[]
  isUsersLoaded: boolean
  userTypes: UserTypeEntity[]
  isUserTypesLoaded: boolean
  userFilter: UserFilter
  selectedUser?: UserEntity
}

interface SetUserFilterAction {
  type: typeof SET_USER_FILTER
  payload: UserFilter
}

interface SetSelectedUserAction {
  type: typeof SET_SELECTED_USER
  payload?: UserEntity
}

interface SetUserLoadedAction {
  type: typeof SET_USERS_LOADED
  payload: boolean
}

interface SetUsersAction {
  type: typeof SET_USERS
  payload: UserEntity[]
}

interface SetUserTypesAction {
  type: typeof SET_USER_TYPES
  payload: UserTypeEntity[]
}

interface SetUserTypesLoadedAction {
  type: typeof SET_USER_TYPES_LOADED
  payload: boolean
}

export type UserAction =
  | SetUserFilterAction
  | SetSelectedUserAction
  | SetUserLoadedAction
  | SetUsersAction
  | SetUserTypesAction
  | SetUserTypesLoadedAction
